// src/services/brandRegistrationApi.js
import { apiFetch } from '../api/client';

function warn(...args) {
  if (typeof console !== 'undefined' && typeof console.warn === 'function') {
    console.warn('[brandRegistrationApi]', ...args);
  }
}

// ---- Public API (used by BusinessRegistration.jsx) ----
async function startRegistration(email) {
  try {
    return await apiFetch('/brand/registration/start', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  } catch (e) {
    warn('startRegistration failed:', e?.message);
    throw e;
  }
}

async function getRegistration(sessionId) {
  try {
    return await apiFetch(`/brand/registration/${encodeURIComponent(sessionId)}`);
  } catch (e) {
    warn('getRegistration failed:', e?.message);
    throw e;
  }
}

async function updateStep(sessionId, stepNumber, stepData) {
  try {
    return await apiFetch(
      `/brand/registration/${encodeURIComponent(sessionId)}/step/${encodeURIComponent(stepNumber)}`,
      {
        method: 'PATCH',
        body: JSON.stringify(stepData || {}),
      }
    );
  } catch (e) {
    warn('updateStep failed:', e?.message, { stepNumber, stepData });
    throw e;
  }
}

async function completeRegistration(sessionId) {
  try {
    return await apiFetch(
      `/brand/registration/${encodeURIComponent(sessionId)}/complete`,
      { method: 'POST' }
    );
  } catch (e) {
    warn('completeRegistration failed:', e?.message);
    throw e;
  }
}

const brandRegistrationAPI = {
  startRegistration,
  getRegistration,
  updateStep,
  completeRegistration,
};

export default brandRegistrationAPI;
